<template>
  <div class="content">
    <center-nav ref="centerNav" @getBuySeatIndex="getBuySeat"></center-nav>
    <!--    有小程序座位席位时且绑定了小程序-->
    <slider-menu
      :menuData="menuData"
      v-if="seatNum > 0 && openAppList.length > 0 && isMerchant == 1"
    ></slider-menu>
    <creditCard v-if="seatNum === 0"></creditCard>

    <!-- v-if="openAppList.length > 0 && isMerchant == 0" -->
    <authorization
      @getBuySeat="getBuySeat"
      @openSet="openSet"
      v-if="openAppList.length > 0 && isMerchant == 0"
    ></authorization>
    <auto v-if="seatNum > 0 && openAppList.length === 0 && !isAuto"></auto>
    <!-- <set v-if="setShow"></set> -->
  </div>
</template>

<script>
import mini from "@/api/mini";
const miniModel = new mini();
import centerNav from "../../../components/centerNav";
import sliderMenu from "@/components/SliderMenu";
import creditCard from "../../pc/zfbMiniProgram/creditCard/index";
import authorization from "../../pc/zfbMiniProgram/authorization/index";
import pay from "../../pc/zfbMiniProgram/pay/index";
import auto from "../../pc/zfbMiniProgram/auto/index";
import set from './set/index.vue'
export default {
  components: {
    centerNav, // 头部导航
    sliderMenu, // 侧边栏
    creditCard,
    authorization,
    pay,
    auto,
    set,
  },
  data() {
    return {
      appKeyRoute:'',
      setShow:false,
      seatNum: "", //小程序席位数量
      openAppList: [],
      isAuto: false, //是否授权
      packagePitList: [],
      isMerchant: 0, // 是否已经绑定商户号
      ipOpenCoupon: false, // 优惠券开关
      menuData: [
        {
          path: "/pc/zfbMiniProgram/home",
          icon: "icon-xcx_refresh_home_n_1",
          title: "主页",
          hidden: false,
          iconSize: "16px",
        },
        {
          path: "/pc/zfbMiniProgram/user",
          icon: "icon-xcx_refresh_user_n_2",
          title: "用户列表",
          hidden: false,
          iconSize: "16px",
        },
        {
          path: "/pc/zfbMiniProgram/order",
          icon: "icon-xcx_refresh_order_n_3",
          title: "影票订单",
          hidden: false,
        },
        {
          path: "/pc/zfbMiniProgram/audit",
          icon: "icon-xcx_refresh_await_n_5",
          title: "提现审核",
          hidden: false,
          iconSize: "16px",
        },
        {
          path: "/pc/zfbMiniProgram/financialDetails",
          icon: "icon-xcx_refresh_detail_n_6",
          title: "资金明细",
          hidden: false,
          iconSize: "16px",
        },
        // {
        //   path: "/pc/zfbMiniProgram/coupon",
        //   icon: "icon-xcx_refresh_detail_n_6",
        //   title: "活动中心",
        //   hidden: false, iconSize: '16px'
        // },
        {
          path: "/pc/zfbMiniProgram/coupon",
          icon: "icon-xcx_refresh_detail_n_6",
          title: "活动中心",
          hidden: false,
          iconSize: "16px",
          children:[]
        },
        {
          path: "/pc/zfbMiniProgram/set",
          icon: "icon-xcx_refresh_set_n_8",
          title: "基础设置",
          hidden: false,
          iconSize: "16px",
        },
        // {
        //   path: "/pc/zfbMiniProgram/promotion",
        //   icon: "icon-xcx_refresh_tool_n_7",
        //   title: "推广工具",
        //   iconSize: "16px",
        //   hidden: false,
        //   children: [
        //     {
        //       path: "/pc/zfbMiniProgram/promotionManage",
        //       title: "推广位管理",
        //     },
        //     {
        //       path: "/pc/zfbMiniProgram/statisticalData",
        //       title: "统计数据",
        //     },
        //   ],
        // },
      ],
    };
  },
  async mounted() {
    console.log('minigrp==222333')
    // var url = location.search;
    // console.log(url,'url=-===1')
    await this.getBuySeat();
    let couponIndex = this.setCouponParams()
    let miniAppTypeZfb = localStorage.getItem('miniAppTypeZfb')
    console.log(miniAppTypeZfb,'miniAppTypeZfb== 3和undefined开启==')
    let appKey = localStorage.getItem('appKeyMini')
    if (this.$route.query.isAuto) {
      this.isAuto = this.$route.query.isAuto;
    }
    if(this.$route.query.appKey) {
      this.appKeyRoute = this.$route.query.appKey
    }
    // await this.getBuySeat();
    // miniAppTypeZfb：1淘宝，2天猫，3抖音，4支付宝，5快手
    // 快手、支付宝、淘宝、天猫、好影抖音影藏 活动中心菜单栏
    // 极光：16045865425测试环境：好影：19235541328正式环境：好影：16663046825
    let couponArr = ['1','2','4','5']
    console.log(couponArr.indexOf(miniAppTypeZfb),'ASD')
    // if(miniAppTypeZfb !== null && couponArr.indexOf(miniAppTypeZfb) === -1){
    //   console.log('AAA==111')
    //   this.getUserCoupon();
    // }else if(miniAppTypeZfb == '3' && appKey == '16045865425') {
    //   console.log('AAA==2222')
    //   this.getUserCoupon();
    // }
    if(miniAppTypeZfb == '4') {
      // 设置活动中心菜单
      // this.setActivityCenter()
    }


    // miniAppTypeZfb：1淘宝，2天猫，3抖音，4支付宝，5快手，禁用菜单“推广工具”
    let miniAppTypeArr = ['1','2','3','4','5']

    console.log(miniAppTypeArr.indexOf(miniAppTypeZfb),'ASD==miniAppTypeZfb')
    console.log(miniAppTypeZfb,'miniAppTypeZfb==')
    if(miniAppTypeZfb !== null && miniAppTypeArr.indexOf(miniAppTypeZfb) === -1) {
      this.menuData.push({
          path: "/pc/zfbMiniProgram/promotion",
          icon: "icon-xcx_refresh_tool_n_7",
          title: "推广工具",
          iconSize: "16px",
          hidden: false,
          children: [
            {
              path: "/pc/zfbMiniProgram/promotionManage",
              title: "推广位管理",
            },
            {
              path: "/pc/zfbMiniProgram/statisticalData",
              title: "统计数据",
            },
          ],
        })
    }else{
      console.log('BBB==')
    }
    await this.getSet(couponIndex)
    if(this.menuData[couponIndex].children.length === 0) {
      // 删除其中一项
      this.menuData.splice(couponIndex, 1);
    }
  },
  methods: {
    setCouponParams() {
      return  this.menuData.findIndex(item => {
        return item.path === '/pc/zfbMiniProgram/coupon'
      })
    },
    async getSet(couponIndex) {
      const res = await miniModel.setMini({
        appKey: localStorage.getItem("appKeyMini"),
      })
      console.log(res,'res======')
      if(res.data.code !== 200) {
        this.$message.error(res.data.message || '获取设置失败zfb')
        return
      }
      let couponItems = this.menuData[couponIndex]
      let data = res.data.data
      let couponTypeList = data.couponType ? data.couponType.split(',').map(Number) : [];
      let miniAppTypeZfb = localStorage.getItem('miniAppTypeZfb')
      if(data.openCoupon) {
        if(miniAppTypeZfb == "4" && couponTypeList.includes(50)) {
          couponItems.children.push(
            {
              path: "/pc/zfbMiniProgram/couponGroupNew",
              title: "优惠券-新",
            },
            // {
            //   path: "/pc/zfbMiniProgram/couponGroup",
            //   title: "优惠券",
            // },
          )
          this.$set(this.menuData, couponIndex, couponItems);
        }
      }
      couponItems.children.push(
        {
          path: "/pc/zfbMiniProgram/couponGroup",
          title: "优惠券",
        },
      )
      this.$set(this.menuData, couponIndex, couponItems);
    },
    setActivityCenter() {
      const item = {
        path: "/pc/zfbMiniProgram/coupon",
        icon: "icon-xcx_refresh_detail_n_6",
        title: "活动中心",
        hidden: false,
        iconSize: "16px",
        children: [
          {
            path: "/pc/zfbMiniProgram/couponGroup",
            title: "优惠券",
          },
          {
            path: "/pc/zfbMiniProgram/couponGroupNew",
            title: "优惠券新",
          },
        ],
      };
      let arr = this.menuData;
      arr.splice(5, 0, item);
      this.menuData = [...arr];
    },
    openSet() {
      this.isMerchant = 1
      this.$router.push({
        path:'/pc/zfbMiniProgram/set'
      })
      // this.setShow = true
      console.log('openSetopenSet')
    },
    // 获取优惠券开关
    getUserCoupon() {
      miniModel
        .userCoupon({
          appKey: localStorage.getItem("appKeyMini"),
        })
        .then((res) => {
          if (res.data.code == 200) {
            console.log('获取优惠券开关菜单==',res)
            console.log(res.data.data.isOpenCoupon,'后台是否开启优惠券菜单权限')
            this.$store.commit("nav/SET_ISOPEN_DOUYIN", res.data.data.isDy);
            const item = {
              path: "/pc/zfbMiniProgram/coupon",
              icon: "icon-xcx_refresh_detail_n_6",
              title: "活动中心",
              hidden: false,
              iconSize: "16px",
            };
            if (res.data.data.isOpenCoupon == 1) {
              let arr = this.menuData;
              arr.splice(5, 0, item);
              this.menuData = [...arr];
            }
            // let arr = this.menuData;
            //   arr.splice(5, 0, item);
            //   this.menuData = [...arr];
          }
        });
    },
    // 获取购买席位数量
    async getBuySeat(appKey) {
      let params = {
        // client:4
        channelType:4
      }
      await miniModel.getMiniNum(params).then((res) => {
        console.log(res,'获取购买席位数量');
        if (res.data.code == 200) {
          this.seatNum = res.data.data.openAppList.length;
          this.packagePitList = res.data.data.packagePitList;
          this.openAppList = res.data.data.openAppList;

          if(this.openAppList.length == 0) return
          console.log('openAppList有数据zfb')
          // 设置缓存
          let miniActiveZfb = localStorage.getItem('miniActiveZfb')
          if(miniActiveZfb === null) {
            console.log('VVV=111==miniActive为null')
            // 取第一个
            this.isMerchant = this.openAppList[0].isMerchant;
            localStorage.setItem('isMerchant',this.openAppList[0].isMerchant)
            localStorage.setItem('miniAppTypeZfb', this.openAppList[0].miniAppType)
            localStorage.setItem('miniActiveZfb',0)
            // appkey
            localStorage.setItem('appKeyMini',this.openAppList[0].appKey)
            // id
            localStorage.setItem('appIdZfb',this.openAppList[0].id)
            localStorage.setItem('appName',this.openAppList[0].appName)
          }else{
            if(this.openAppList[miniActiveZfb]) {
              this.isMerchant = this.openAppList[miniActiveZfb].isMerchant;
              localStorage.setItem('isMerchant',this.openAppList[miniActiveZfb].isMerchant)
              localStorage.setItem('miniAppTypeZfb', this.openAppList[miniActiveZfb].miniAppType)
              // localStorage.setItem('miniActiveZfb',0)
              // appkey
              localStorage.setItem('appKeyMini',this.openAppList[miniActiveZfb].appKey)
              // id
              localStorage.setItem('appIdZfb',this.openAppList[miniActiveZfb].id)
              localStorage.setItem('appName',this.openAppList[miniActiveZfb].appName)
            }else{
              // 取第一个
              this.isMerchant = this.openAppList[0].isMerchant;
              localStorage.setItem('isMerchant',this.openAppList[0].isMerchant)
              localStorage.setItem('miniAppTypeZfb', this.openAppList[0].miniAppType)
              localStorage.setItem('miniActiveZfb',0)
              // appkey
              localStorage.setItem('appKeyMini',this.openAppList[0].appKey)
              // id
              localStorage.setItem('appIdZfb',this.openAppList[0].id)
              localStorage.setItem('appName',this.openAppList[0].appName)
            }

          }
          if (appKey != undefined) {
            console.log('授权资质AA11')
            for (let index in this.openAppList) {
              if (this.openAppList[index].appKey == appKey) {
                this.isMerchant = this.openAppList[index].isMerchant;
                localStorage.setItem(
                  "isMerchant",
                  this.openAppList[index].isMerchant
                );
              }
            }
          } else {
            console.log('授权资质BB11')
            if (localStorage.getItem("isMerchant")) {
              console.log('授权资质BB11==1')
              this.isMerchant = localStorage.getItem("isMerchant");
            } else {
              console.log('授权资质BB11==2')
              if (this.openAppList.length > 0) {
                this.isMerchant = this.openAppList[0].isMerchant;
              }
            }
            console.log(this.$route.query.appKey,'this.$route.query.appKey')
            // 授权页面传值，选中对应项
            if(this.$route.query.appKey){
              console.log('有传appkey')
              for (let index in this.openAppList) {
                console.log('循环')
                // appkey相同
                if(this.openAppList[index].appKey == this.$route.query.appKey) {
                  this.isMerchant = this.openAppList[index].isMerchant;
                  localStorage.setItem('isMerchant',this.openAppList[index].isMerchant)
                  localStorage.setItem('miniActiveZfb',index)
                  // appkey
                  localStorage.setItem('appKeyMini',this.$route.query.appKey)
                  // id
                  localStorage.setItem('appIdZfb',this.openAppList[index].id)
                  localStorage.setItem('miniAppTypeZfb',this.openAppList[index].miniAppType)
                  localStorage.setItem('appName',this.openAppList[index].appName)
                  console.log(index,'index===56有传appkey的索引',this.openAppList[index])
                }
              }
            }
            if (localStorage.getItem("appIdZfb") != null) {
              console.log('授权资质BB11==3')
              const appIdZfb = localStorage.getItem("appIdZfb");
              for (let index in this.openAppList) {
                if (this.openAppList[index].id == appIdZfb) {
                  this.isMerchant = this.openAppList[index].isMerchant;
                  this.appKey = this.openAppList[index].appKey;

                  localStorage.setItem('miniActiveZfb',index)
                  localStorage.setItem('appName',this.openAppList[index].appName)
                  // localStorage.setItem('miniActiveZfb',3)
                  console.log(index,'index=getItem("appIdZfb")')
                  break;
                } else {
                  this.isMerchant = this.openAppList[0].isMerchant;
                  this.appKey = this.openAppList[0].appKey;
                }
              }
              console.log(appIdZfb,this.appKey,this.isMerchant,'getItem("appIdZfb")')
            }
          }
          this.$refs.centerNav.getBuySeat();
          console.log(
            "debug:________________this.isMerchant______________",
            this.isMerchant
          );
          // if (this.$refs.router != undefined) {
          //   this.$refs.router.getBuySeat()
          // }
        } else {
          this.$message.error(res.data.info);
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/views/pc/zfbMiniProgram/index.vue